﻿

	 import { SearchFilter } from '@models/search-filters/SearchFilter';
    
    export class MultimediaContentSearchFilter extends SearchFilter {
        
    }
